<template>
  <div class="sidebar">
    <nav>
      <ul>
        <li>
          <router-link to="/">Aktuelles</router-link>
        </li>
        <li>
          <router-link to="/referenzen">Referenzen</router-link>
        </li>
        <li>
          <router-link to="/about">Über uns</router-link>
        </li>
        <li>
          <router-link to="/kontakt">Kontakt</router-link>
        </li>
      </ul>
    </nav>

    <footer>
      <p class="companyName">
        Preis &amp; Preis OHG
      </p>
      <p class="companyDescription">
        Werkstätten<br />
        für Restaurierung
      </p>
      <p>
        <router-link to="/impressum">Impressum &amp; Datenschutz</router-link>
      </p>
    </footer>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "home",
  components: {},
};
</script>
